// extracted by mini-css-extract-plugin
export default {"title":"Style_title__Cu4T6","button":"Style_button__RNqXV","like":"Style_like__1Sg4J"};